/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-move': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15.625 6.875l-.881.881 1.612 1.619h-5.731V3.644l1.619 1.612.881-.881L10 1.25 6.875 4.375l.881.881 1.619-1.612v5.731H3.644l1.612-1.619-.881-.881L1.25 10l3.125 3.125.881-.881-1.612-1.619h5.731v5.731l-1.619-1.612-.881.881L10 18.75l3.125-3.125-.881-.881-1.619 1.612v-5.731h5.731l-1.612 1.619.881.881L18.75 10z"/>'
  }
})
